export var UG_EVENT;

(function (UG_EVENT) {
  UG_EVENT["PAGE_VIEW"] = "page_view";
  UG_EVENT["PAGE_VIEW_3S"] = "page_view_3s";
  UG_EVENT["REG_CLICK"] = "reg_click";
  UG_EVENT["REG_DONE"] = "reg_done";
  UG_EVENT["LOGIN_CLICK"] = "login_click";
  UG_EVENT["LOGIN_DONE"] = "login_done";
  UG_EVENT["NAV_CLICK"] = "nav_click";
  UG_EVENT["NAV_LEARN_MORE"] = "nav_learn_more";
  UG_EVENT["LEARN_MORN_CLICK"] = "learn_morn_click";
  UG_EVENT["CAT_CLICK"] = "cat_click";
})(UG_EVENT || (UG_EVENT = {}));

const TT_ADS_EVENT_MAP = {
  [UG_EVENT.PAGE_VIEW]: 'ViewContent',
  [UG_EVENT.PAGE_VIEW_3S]: 'AddPaymentInfo',
  [UG_EVENT.REG_CLICK]: 'AddToCart',
  [UG_EVENT.REG_DONE]: 'CompleteRegistration',
  [UG_EVENT.LOGIN_CLICK]: 'AddToWishlist',
  [UG_EVENT.LOGIN_DONE]: 'CompletePayment',
  [UG_EVENT.NAV_CLICK]: 'ClickButton',
  [UG_EVENT.NAV_LEARN_MORE]: 'SubmitForm',
  [UG_EVENT.LEARN_MORN_CLICK]: 'Contact',
  [UG_EVENT.CAT_CLICK]: 'Subscribe'
};
const FB_ADS_EVENT_MAP = {
  [UG_EVENT.PAGE_VIEW]: 'PageView',
  [UG_EVENT.PAGE_VIEW_3S]: 'AddPaymentInfo',
  [UG_EVENT.REG_CLICK]: 'AddToCart',
  [UG_EVENT.REG_DONE]: 'CompleteRegistration',
  [UG_EVENT.LOGIN_CLICK]: 'AddToWishlist',
  [UG_EVENT.LOGIN_DONE]: 'CompletePayment',
  [UG_EVENT.NAV_CLICK]: 'Search',
  [UG_EVENT.NAV_LEARN_MORE]: 'Lead',
  [UG_EVENT.LEARN_MORN_CLICK]: 'Contact',
  [UG_EVENT.CAT_CLICK]: 'Lead'
};
export const ugMonitor = event => {
  // GA
  window.gtag && window.gtag('event', event); // TT-ads

  window.ttq && window.ttq.track(TT_ADS_EVENT_MAP[event]); // FB

  window.fbq && window.fbq('track', FB_ADS_EVENT_MAP[event]);
};